import { createFileRoute } from '@tanstack/react-router';

import { GroupsPage } from '@/features/teacher/GroupsPage';

export const Route = createFileRoute('/_authed/teacher/groups')({
  validateSearch: (search): { group?: string; student?: string } => ({
    group: typeof search.group === 'string' ? search.group : undefined,
    student: typeof search.student === 'string' ? search.student : undefined,
  }),
  component: GroupsPage,
});
